// eslint-disable-next-line import/no-unresolved
import platformsOriginal from 'platforms_config';
import adPlatformsOriginal from '../../config/ad_platforms.yml';
import { deepHashCamelCase, deepHashCamelCaseValues } from '../utils/convert_keys';

const platforms = deepHashCamelCaseValues(platformsOriginal);
export const adPlatforms = deepHashCamelCaseValues(adPlatformsOriginal);

export const platformKeys = Object.keys(platforms);
export const allPlatformKeys = new Set([...platformKeys, ...Object.keys(adPlatforms)]);

export const camelCasePlatformPayload = payload => deepHashCamelCase(payload, allPlatformKeys);

export default platforms;
